import React from "react";
import PropTypes from "prop-types";
import { Button, Tooltip, withStyles } from "@material-ui/core";

const ButtonForm = withStyles((theme) => ({
  root: {
    padding: theme.spacing(1),
    borderRadius: "15px",
    textTransform: "none",
    fontWeight: "600",
    "&:hover": {
      backgroundColor: theme.palette.primary.main,
    },
    "&:disabled": {
      //backgroundColor: theme.palette.secondary.dark,
    },
    //marginBottom: "0.5rem",
  },
}))(Button);

export const ButtonSaveDocuments = ({
  title,
  fontSize,
  text,
  onClick,
  colorProperty,
  colorletter,
  ...others
}) => {
  return (
    <>
      <Tooltip title={title}>
        <ButtonForm
          {...others}
          fullWidth
          variant="contained"
          color={colorProperty}
          disableElevation
          style={{ color: colorletter, fontSize: fontSize }}
          onClick={onClick}
        >
          {text}
        </ButtonForm>
      </Tooltip>
    </>
  );
};

ButtonSaveDocuments.prototypes = {
  /**
   * String button text
   */
  text: PropTypes.string.isRequired,
  /**
   * Color button
   */
  colorProperty: PropTypes.oneOf(["primary", "secondary", "default"]),
  /**
   * Function for click button
   */
  onClick: PropTypes.func,
};
